import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import LogoMarquee from "@/components/LogoMarquee";
import NumbersProof from "@/components/NumbersProof";
import CoreIdea from "@/components/CoreIdea";
import LinkedInSystem from "@/components/LinkedInSystem";
import ClientSpotlight from "@/components/ClientSpotlight";
import Process from "@/components/Process";
import About from "@/components/About";
import Background from "@/components/Background";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function App() {
  return (
    <div className="min-h-screen bg-[#09090B] text-[#F3F0E8] antialiased">
      <Header />
      <main>
        <Hero />
        <LogoMarquee />
        <NumbersProof />
        <CoreIdea />
        <LinkedInSystem />
        <ClientSpotlight />
        <Process />
        <About />
        <Background />
        <Testimonials />
        <Faq />
        <FinalCta />
        <ContactSection />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121214",
            border: "1px solid rgba(243,240,232,0.14)",
            color: "#F3F0E8",
          },
        }}
      />
    </div>
  );
}
